<template>
  <div class="page-nanilist" v-show="isMounted">
    <div class="common-wrap">
      <div class="paeparation">
        <div class="search">
          <el-input class="ipt" clearable size="large" v-model="archiveParam.archiveTitle" placeholder="输入文章标题"></el-input>
          <div class="btn" v-on:click="changePage(1)">
            <i class="el-icon-search"></i> 搜索
          </div>
        </div>
        <ul class="nselect-type clearfix">
          <li :class="{ active: selectColumnId == 0 }" v-on:click="searchByColumnId(0)"><span class="tit">全部</span></li>
          <li v-for="(item,index) in columnList" :key="index" :class="{ active: selectColumnId== item.id }" v-on:click="searchByColumnId(item.id)">
            <span class="tit">{{item.columnName}}</span><span class="count">{{item.columnCount}}</span>
          </li>
          <!--<li>
            <span class="tit">动画前期</span>
            <span class="count">222</span>
          </li>
          <li >
            <span class="tit">动画前期</span>
            <span class="count">222</span>
          </li>-->
        </ul>
      </div>

      <!--:to="{ path: '/column/themedetail', query: { id: item.id } }"
      :to="{ path: '/column/davdetail', query: { id: item.id } }"-->
      <div class="projn-list nproject" >


        <div class="projn-item" v-for="(item,index) in newArchivePage.list" :key="index">
          <a :href="item.columnType == 1 ?baseUrl+'/column/davdetail?id='+item.id+'&plate='+item.belongSection:baseUrl+'/column/themedetail?id='+item.id+'&plate='+item.belongSection" target="_blank" class="left-img"
            :style="{backgroundImage: 'url(' + item.thumbnail + ')'}"
          >
          </a>
          <a :href="item.columnType == 1 ?baseUrl+'/column/davdetail?id='+item.id+'&plate='+item.belongSection:baseUrl+'/column/themedetail?id='+item.id+'&plate='+item.belongSection" target="_blank" class="mobile-mask"></a>
          <div class="itemn-info">
            <div class="item-tit">
              <div class="tit-type clearfix">
                <a :href="item.columnType == 1 ?baseUrl+'/column/davdetail?id='+item.id+'&plate='+item.belongSection:baseUrl+'/column/themedetail?id='+item.id+'&plate='+item.belongSection" target="_blank" class="tit-nam">
                  <span class="n-type">[{{item.columnName}}]</span>
                  {{item.archiveTitle}}
                </a>
              </div>
              <a  :href="baseUrl+'/home?userId='+item.creatorId" target="_blank" class="user-info clearfix">
                <img class="u-avatar" :src="item.imgUrl" :alt="item.imgUrl">
                <span class="name">{{item.creatorName}}</span>
              </a>
            </div>
            <div class="pro-type">{{item.archiveContent}}</div>
            <div class="btn-has-user">
              <div class="left-info clearfix">
                <i class="icon view"></i>
                <span class="count">{{item.viewCount}}</span>
                <i class="icon zan"></i>
                <span class="count">{{item.likeCount}}</span>
                <i class="icon pinglun"></i>
                <span class="count">{{item.commentCount}}</span>
                <i class="icon share"></i>
                <span class="count">{{item.shareCount}}</span>
              </div>
              <div class="hs-user">{{item.createTime | formatTime}}</div>
            </div>
          </div>
        </div>


      </div>
      <div class="pagintion-f"  v-if="isMounted && newArchivePage.total>0">
        <el-pagination
                background
                @current-change="changePage"
                layout="prev, pager, next,jumper"
                :current-page.sync="archiveParam.pageIndex"
                :page-size="archiveParam.pageSize"
                :total="newArchivePage.total"
                :hide-on-single-page="true"
        >
        </el-pagination>
      </div>

    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import columnApi from "@/api/column";
  import updateTdk from "@/utils/tdk";
  import productionApi from "@/api/production";
  import archiveApi from "@/api/archive";
  import utilTools from "@/utils/utilTools";
  import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['newArchivePage'])
  },
  data () {
    return {
      baseUrl:process.env.config.RRDH_HOST,
      headTitle: "人人动画",
      headKeywords: "keywords---rrdh",
      headDesc: "description---rrdh",
      isMounted: false, //for control not ssr render

      searchIpt: '',
      plate:3,

      columnParam:{
        columnType:0,
      },
      columnList:[],


      archiveParam:{
        archiveTitle:"",
        columnId:'',
        deleteFlag: 0,
        pageIndex: 1,
        pageSize: 6,
      },
      archiveData:[],
      total:0,
      selectColumnId:0,
    }
  },
  tdk() {
    return {
      title: this.headTitle,
      description: this.headDesc,
      keywords: this.headKeywords,
      ssrHeadAddInfo: `<link rel="canonical" href="http://www.renrendonghua.com">`
    };
  },
  serverPrefetch() {
    this.fetchData()
    return this.initData();
  },
  // beforeRouteUpdate(to, from, next) {
  //   // 一般建议路由变更采用计算属性或者store直接绑定
  //   // 特殊情况处理可以采用如下方案 重新注册数据返回处理
  //   this.initData()
  //   next();
  // },

  mounted(){

    this.fetchData()
    this.initData().then(()=>{
      this.parseHtml(this.newArchivePage.list)
      this.fetchDataMounted()
    })
    //this.getColumnList(paramPageIndex)

  },
  methods:{
    parseHtml(list){
      list.forEach(item=>{
        //let desc = item.productionInrto.replace(/<\/?.+?>/g,"").trim()
        let desc = utilTools.parseHtml(item.archiveContent)
        item.archiveContent =desc//.substr(0,80);
      })
    },
    fetchData(){
      let plate = this.$route.query.plate
      this.plate = plate

      let paramPageIndex = this.$route.query.toPageNum
      let selectColumnId = this.$route.query.columnId
      let pName = this.$route.query.pName

      if(!paramPageIndex){
        paramPageIndex = 1
      }
      this.archiveParam.pageIndex =Number(paramPageIndex)

      if(selectColumnId){
        this.selectColumnId = selectColumnId
        this.archiveParam.columnId = selectColumnId
      }
      if(pName){
        this.archiveParam.archiveTitle = pName
        this.columnParam.columnName = pName
      }
    },
    fetchDataMounted(){
      setTimeout(()=>{
        this.isMounted = true;
        this.columnParam.columnName = this.archiveParam.archiveTitle
        columnApi.getColumnList(this.columnParam).then( reColumn =>{
          this.columnList = reColumn.response
          //this.search(page)
        })
      },1000)
    },
    initData(){
      this.$loading(true)
      const cookies = this.$ssrContext && this.$ssrContext.cookies
      return this.$store.dispatch("FETCH_NEW_ARCHIVE_PAGE", {params: this.archiveParam,cookies:cookies}).finally(() => {
        this.$loading(false)
        this.setSeo();
        updateTdk.call(this);
      })
    },
    setSeo() {
      this.headTitle = "人人动画网【官网】";
      this.headKeywords = "人人动画网,动画短视频,短视频";
      this.headDesc =
              "人人动画网，是一个动画短视频分享社区，凭借丰富的快速动画创意资源，和行业深厚的动画技术背景，助力每个人实现自己的动画梦。";
    },

    getColumnList(page){
      this.columnParam.columnName = this.archiveParam.archiveTitle
      columnApi.getColumnList(this.columnParam).then( reColumn =>{
        this.columnList = reColumn.response
        this.search(page)
      })
    },

    searchByColumnId(columnId){
      if(this.selectColumnId == columnId ){
        columnId = 0
      }
      this.selectColumnId = columnId
      this.archiveParam.columnId = columnId
      //this.getColumnList(1)
      this.changePage(1)
    },
    search(page){
      this.archiveParam.pageIndex = page
      archiveApi.getArchivePage(this.archiveParam).then(rePro => {
        this.archiveData = rePro.list

        this.archiveData.forEach(item=>{
          //let desc = item.archiveContent.replace(/<\/?.+?>/g,"").trim()
          let desc = utilTools.parseHtml(item.archiveContent)
          item.archiveContent =desc.substr(0,80);
        })
        this.total = rePro.total
        this.archiveParam.pageIndex = rePro.pageNum
      })
    },
    changePage(page){
      let urlNow=window.location.href

      if(urlNow.indexOf("toPageNum") > 0){
        urlNow = urlNow.substr(0,urlNow.indexOf("&toPageNum="))
      }
      let url = urlNow+"&toPageNum="+page
      if(this.archiveParam.columnId){
        url += "&columnId="+this.archiveParam.columnId
      }
      if(this.archiveParam.archiveTitle){
        url += "&pName="+this.archiveParam.archiveTitle
      }
      window.location.href= url

    },
  }
}
</script>

<style scoped lang="less">
@import "../../project/pro.less";
.page-nanilist {
  padding-top: @NAVHEIGHT;
  
}
.pagintion-f {
  padding: 20px 0 40px;
  text-align: center;
}
</style>
